export default __webpack_public_path__ + "static/media/Killer Bee Queen.0f32f66f.png";